import { BenefitCardTypeEnum } from '~/types';

export const BENEFITS_CARDS = [
  {
    title: 'Digitising Processes & Increasing Time Efficiency',
    description: 'The platform automates various administrative tasks, such as record-keeping and prescription tracking. This saves valuable time for clinical teams, enabling them to focus more on patient care.',
    image: '/images/cards/automated-processes.png',
  },
  {
    title: 'Higher Patient Satisfaction Through Premium Service',
    description: 'Healistic ensures a premium service, competitive medication prices and optimised stock availability. We make sure your patients do NOT have to chase their medication, wait in queues or overpay on the high street.',
    image: '/images/cards/patient-satisfaction.png',
  },
  {
    title: 'Enhanced Safety & Security',
    description: 'Reduced prescription and dispensing errors through smart prescribing features. Healistic e-prescriptions are sent to pharmacies in a secure and encrypted format for fulfilment.',
    image: '/images/cards/data-security.png',
  },
  {
    title: 'Repeat Prescription Automation',
    description: 'Automatically generate refills based on desired frequency, giving peace of mind to both patients and doctors.',
    image: '/images/cards/prescription-automation.png',
    type: BenefitCardTypeEnum.secondary,
  },
  {
    title: 'Controlled Drugs Fulfilment',
    description: 'We provide a streamlined process to fulfil prescriptions for schedule 2-5 controlled drugs, complying with all relevant regulations and safety protocols.',
    image: '/images/cards/controlled-drugs.png',
    type: BenefitCardTypeEnum.secondary,
  },
];
